import { render, staticRenderFns } from "./FreePlanBanner.vue?vue&type=template&id=8992c830&"
import script from "./FreePlanBanner.vue?vue&type=script&lang=ts&"
export * from "./FreePlanBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports